import { useEffect, useState } from 'react';
import Layout from '../layouts/Layout'
import {Navigate } from 'react-router-dom'
import { useDispatch} from 'react-redux';
import { resetFiltrosLiquidaciones } from '../../redux/filtroLiquidacionesSlice';
import { resetFiltrosFacturas } from '../../redux/filtroFacturasSlice';

function Error() {

  const dispatch = useDispatch()

  const [redirect, setRedirect] = useState(false);

  if (sessionStorage.length>0){

    sessionStorage.clear()
  }

  useEffect(() => {
    
    dispatch(resetFiltrosLiquidaciones())
    dispatch(resetFiltrosFacturas())
    
    // Establece el tiempo de espera en milisegundos (por ejemplo, 3000 ms = 3 segundos)
    const timeout = 2000

    // Inicia el temporizador
    const timerId = setTimeout(() => {
      // Establece el estado para redirigir después del tiempo de espera
      setRedirect(true)      
    }, timeout)

    // Limpia el temporizador al desmontar el componente o al redirigir antes del tiempo de espera
    return () => clearTimeout(timerId)
  }, []); // El segundo parámetro vacío [] garantiza que el efecto se ejecute solo una vez al montar el componente

  // Redirige si el estado de redirect es true
  if (redirect) {
    return <Navigate to="/" replace />
  }

  return (
    <Layout>
      <div className='flex flex-col justify-center text-center mt-20 mb-20'>
        <p className="tracking-wide text-gray-500 md:text-[2rem]">Tu sesión se ha cerrado</p>
        <p className="tracking-wide text-gray-500 md:text-[1.2rem]">Por favor iniciala nuevamenente!</p>
      </div>
    </Layout>
  )
}

export default Error